import { Component } from "@angular/core";

@Component({
  selector: 'gen-unauthorized',
  template: '<h1 style="margin: 0 auto">\n' +
            ' 401 - UnAuthorized!\n' +
            '</h1>\n'
})
export class unauthorizedComponent {

}
